import React from 'react'
import ForgotPasswordComponent from './components/ForgotPasswordComponent'

const ForgotPassword: React.FC = () => {
  return (
    <>
      <ForgotPasswordComponent />
    </>
  )
}

export default ForgotPassword
